/* istanbul ignore file */
import { FieldProps, useFieldHelper } from 'framework/ui/field';
import { CustomBadge } from 'framework/ui/ui-builder';

const ApplicationCandidateScoreBadge = (props: FieldProps) => {
  const { getValue } = useFieldHelper(props);
  const value = getValue() as any;

  const getValueText = () => (!value ? 'N/A' : value);

  const getColor = () => {
    if (!value) {
      return 'default';
    }

    if (value < 30) {
      return 'error';
    }

    if (value > 70) {
      return 'success';
    }

    return 'warning';
  };

  return <CustomBadge text={getValueText()} color={getColor()} {...props} />;
};

export default ApplicationCandidateScoreBadge;
